"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 144px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 72px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  font-size: 96px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandIconLarge = exports.brandIconSmall = exports.brandIconBase = void 0;

var _stylitas = require("@creditas/stylitas");

var brandIconBase = function brandIconBase(_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return (0, _stylitas.css)(_templateObject(), _stylitas.utilities.palette.color(theme, color));
};

exports.brandIconBase = brandIconBase;

var brandIconSmall = function brandIconSmall(_ref2) {
  var fontSize = _ref2.fontSize;
  return fontSize === 'small' && (0, _stylitas.css)(_templateObject2());
};

exports.brandIconSmall = brandIconSmall;

var brandIconLarge = function brandIconLarge(_ref3) {
  var fontSize = _ref3.fontSize;
  return fontSize === 'large' && (0, _stylitas.css)(_templateObject3());
};

exports.brandIconLarge = brandIconLarge;